import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";

import "react-datetime/css/react-datetime.css";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import useAxiosFile from "../../actions/useaxios";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router";
import { LoadToast, updateToast } from "../../actions/common";

function SupportTicketList() {
  const navigate = useNavigate();
  const [dtlists, setDtlists] = useState([]);
  const { toggle } = useSelector((state) => state.admin_panel.User);
  const axiosFile = useAxiosFile();

  useEffect(() => {
    showdata();
  }, []);

  const showdata = async () => {
    console.log("ddddd");
    var data = await axiosFile.GetSupportTicketList();
    console.log("vvvv", data);
    setDtlists(data?.data);
  };

  const submitbtn = async (cell) => {
    navigate(`/supportticketdetail`, { state: cell });
  };

  const columns = [
    {
      dataField: "UserId",
      text: "Email Id",
      sort: true,
      formatter: (cell, row) => (
        <div>
          {console.log('cellcell', cell, row)}
          {cell?.EmailId}
        </div>
      ),
    },
    {
      dataField: "Message",
      text: "Message",
      sort: true,
      formatter: (cell, row) => <div>{cell?.length > 20 ? cell.substring(0, 20) + "..." : cell}</div>,
    },
    {
      dataField: "ticketStatus",
      text: "Ticken Status",
      sort: true,
      formatter: (cell, row) => (
        <div className="">
          {cell}
        </div>
      ),
    },
    {
      dataField: "hideshow",
      text: "View",
      formatter: (cell, row) => (
        <button
          class="blue_btn add_deliveryprsn dp_btn_hover"
          type="button"
          onClick={() => submitbtn(row)}
        >
          View/Reply
        </button>
      ),
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });

  return (
    <>
      <section id="content-wrapper">
        <div class="row">
          <div className="top_title_sec">
            <div>
              <p className="page_title">Support Ticket List</p>
            </div>
          </div>
        </div>
        <div className="row mt-4 mx-auto">
          <div className="sec_border">
            <div className="row">
              {
                dtlists?.length > 0 &&
                <div className="ffd_table mar_bot vendor_table_align">
                  <BootstrapTable
                    bootstrap4
                    keyField="id"
                    columns={columns}
                    data={dtlists}
                    pagination={pagination}
                    noDataIndication="No Support Ticket found"
                  />
                </div>
              }
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default SupportTicketList;
